// extracted by mini-css-extract-plugin
module.exports = {"departments":"ne","departmentHeading":"oe","departmentSection":"pe","departmentName":"qe","departmentLink":"re","expandIcon":"se"};